// @ts-nocheck
import {
    Flex,
    Input,
    Menu,
    MenuButton,
    MenuList
} from "@chakra-ui/react";
import { CloseCircleIcon } from "@root/assets";
import { CalenderIcon } from "@root/assets/icons";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

const CustomDateRangePicker = ({ onDateSelect, onClear, dates }: any) => {
    const { t } = useTranslation("common");
    const [startDate, endDate] = dates
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);

    const handleDateChange = (dates) => {
        if (onDateSelect) {
            onDateSelect(dates);
        }
    };

    const clearDates = () => {
        if (onClear) {
            onClear();
        }
    };

    const formatDateRange = () => {
        if (!startDate || !endDate) return "";
        const startString = startDate.toLocaleDateString();
        const endString = endDate.toLocaleDateString();
        return `${startString} - ${endString}`;
    };
    
    return (
        <>
            <Menu>
                <Flex alignItems="center" position="relative">
                    <MenuButton minW={'240px'}>
                        <Input
                            readOnly
                            placeholder={t('user_dashboard.dateRange')}
                            value={formatDateRange()}
                            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                            size="md"
                            minW={'240px'}
                        />
                    </MenuButton>
                    {(!startDate && !endDate) ? (
                        <CalenderIcon
                            position="absolute"
                            right="6px"
                            color={'theme.gray.300'}
                            top="15px"
                        />
                    ) : (
                        <CloseCircleIcon
                            position="absolute"
                            right="6px"
                            color={'theme.gray.300'}
                            top="18px"
                            onClick={clearDates}
                            cursor={'pointer'}
                        />
                    )}
                </Flex>
                <MenuList
                    boxShadow={'0px 0px 20px 0px rgba(0 , 0, 0,0.1)'}
                    p={0}
                    m={0}
                >
                    <DatePicker
                        selected={dates?.[0]}
                        onChange={handleDateChange}
                        startDate={dates?.[0]}
                        endDate={dates?.[1]}
                        selectsRange
                        inline
                    />
                </MenuList>
            </Menu>
        </>
    );
};

export { CustomDateRangePicker };
